import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../../utils/metaPixel';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
  trackCheckout?: boolean;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel,
  trackCheckout = false
}: ButtonProps) {
  const handleClick = () => {
    if (trackCheckout) trackInitiateCheckout();
    onClick?.();
  };
  const styles = {
    primary: 'bg-cta text-cta-foreground shadow-lg shadow-cta/30 ring-1 ring-inset ring-foreground/10 transition-[background-color,transform] hover:bg-cta-hover active:scale-[0.98]',
    secondary: 'bg-surface text-foreground border border-primary/40 transition-[background-color,transform] hover:bg-surface-hover active:scale-[0.98]',
    outline: 'border-2 border-primary bg-transparent text-primary transition-colors hover:bg-surface'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-202" data-mp="xmnzsaimltte">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="17fczy98q7l9f" />}
      </a>;
  }
  return <button type="button" onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-204" data-mp="1ldl534fx1svo">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-205" data-mp="1hdj46xi093hg" />}
    </button>;
}